import { SdkContext } from '../internal'
import { type SearchResponse, type SearchParams } from '@/types/search'

// The official published SDK does not yet expose search endpoints
// (reported to the SDK owner). Calls go through the client's generic
// request pipeline so headers, auth and error handling stay consistent.
export class SearchResource {
  constructor(private ctx: SdkContext) {}

  async search(params: SearchParams): Promise<SearchResponse> {
    return this.ctx.call({ httpMethod: 'GET', path: '/search' }, { query: params })
  }

  async suggest(query: string): Promise<string[]> {
    return this.ctx.call({ httpMethod: 'GET', path: '/search/suggest' }, { query: { query } })
  }

  async trending(): Promise<string[]> {
    return this.ctx.call({ httpMethod: 'GET', path: '/search/trending' })
  }

  async recent(): Promise<string[]> {
    return this.ctx.call({ httpMethod: 'GET', path: '/search/recent' })
  }
}
